/*
 * VoxPontBetaGateNotice — explanatory screen shown when a signed-in user cannot
 * enter a gated VoxPont product page.
 *
 * Replaces the prior silent `<Navigate to="/voxpont">` for the 'none' state,
 * which dumped users on the marketing landing with no explanation. Also unifies
 * the previously-inline 'expired' screen so both gate states look the same.
 *
 * Brand note: bespoke navy + gold surface (the established VoxPont brand-surface
 * exception to the HealthDesk MUI theme, matching VoxPontAuthPage /
 * VoxPontOnboardingPage / the old inline expired blocks). Styling is
 * self-contained via explicit brand tokens so it renders correctly whether or
 * not a parent ThemeProvider is mounted (VoxPont100 gates before its theme wrap).
 */
import React from "react";
import { Box, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { marketingHubPath } from "pages/voxpontmarketing/voxpontMarketingRouting";

const NAVY_DEEP = "#0C1E36";
const GOLD = "#d4af37";
const GOLD_CHAMPAGNE = "#c8a23a";

const COPY = {
  none: {
    heading: "VoxPont is in private beta",
    body:
      "Access is currently invite-only. If you have an invite link, open it to activate your access — otherwise contact your VoxPont representative for an invite.",
  },
  expired: {
    heading: "Your VoxPont Beta access has expired",
    body: "Thanks for helping test VoxPont.",
  },
};

export default function VoxPontBetaGateNotice({ variant = "none" }) {
  const copy = COPY[variant] ?? COPY.none;

  return (
    <Box
      sx={{
        minHeight: "100dvh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        p: 3,
        textAlign: "center",
        bgcolor: NAVY_DEEP,
      }}
    >
      <Typography variant="h6" sx={{ color: GOLD }}>
        {copy.heading}
      </Typography>
      <Typography
        variant="body2"
        sx={{ color: "rgba(255,255,255,0.6)", maxWidth: 420 }}
      >
        {copy.body}
      </Typography>
      <Link component={RouterLink} to={marketingHubPath()} sx={{ color: GOLD_CHAMPAGNE }}>
        Learn more about VoxPont
      </Link>
    </Box>
  );
}
